module["exports"] = [
  "Acesso",
  "Alameda",
  "Avenida",
  "Azinhaga",
  "Bairro",
  "Beco",
  "Calçada",
  "Caminho",
  "Escadas",
  "Estrada",
  "Jardim",
  "Ladeira",
  "Largo",
  "Praça",
  "Praceta",
  "Quinta",
  "Rua",
  "Travessa",
  "Urbanização",
  "Viela"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_PT/address/street_prefix.js
// module id = 3418
// module chunks = 1610